import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "funcBtn" }

import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import router from '@/router';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const { t } = useI18n();
const store = useStore();

function changeMenu() {
	store.commit('app/UPDATE_SIDEBARSTATUS');
}

function logout() {
	store.commit('app/RESET_INFO');
}

// export default {
//   components: {},
//   data() {},
//   methods: {
//     isMatch(path) {
//       if (!path) return false;
//       return path.test(this.$route.fullPath);
//     },
//     toAbout() {
//       this.$router.push("/about");
//     },
//   },
// };

return (_ctx: any,_cache: any) => {
  const _component_Locale = _resolveComponent("Locale")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: changeMenu,
      class: "menu"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "material-symbols-outlined" }, " menu ", -1)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Locale),
      _cache[2] || (_cache[2] = _createTextVNode(" | ", -1)),
      _createElementVNode("button", {
        type: "button",
        onClick: logout,
        class: "logout"
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-symbols-outlined" }, " lock ", -1)),
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.logout')), 1)
      ])
    ])
  ]))
}
}

})